import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Operator } from '../common/models/operator';
import { Merchant, MerchantOperatorContainer } from '../common/models/merchant';
import { Plan } from '../common/models/plan';
import { OperatorDetails } from '../models/operator-details';
import { map, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProviderService {
  baseApi = environment.baseCloud7CmsApiUrl + '/api';
  public onChangeOperatorSource = new Subject<Operator>();
  public onChangeOperator$ = this.onChangeOperatorSource.asObservable();

  public onFirstMerchantSource = new Subject<MerchantOperatorContainer>();
  public onFirstMerchant$ = this.onFirstMerchantSource.asObservable();
 
  setOnChangeOperatorSource(operator : Operator){
    this.onChangeOperatorSource.next(operator);
  }
  constructor(private http: HttpClient) { }

  loadOperators() {
    return this.http.get<Operator[]>(
      this.baseApi + '/serviceprovider/operators'
    );
  }

  loadMerchants(operator: string) {
    const headers = this.getOperatorHeader(operator);
    return this.http.get<Merchant[]>(
      this.baseApi + '/serviceprovider/merchants',
      { headers }
    );
  }

  loadPackages(merchant: string, operator: string) {
    const headers = this.getOperatorHeader(operator);

    return this.http
      .get<Plan[]>(this.baseApi + '/serviceprovider/plans/' + merchant, {
        headers: headers,
      })
      .pipe(
        map((plans) => plans.map((plan) => ({ ...plan, isChecked: false })))
      );
  }

  private getOperatorHeader(operator: string) {
    const headers = new HttpHeaders({ Operator: operator });
    return headers;
  }

  getOperatorDetails(
    operator: string,
    serviceIds: string[],   
    source: string = 'live',
    fromDate?: Date,
    toDate?: Date,
  ) {


    let params = new HttpParams();
    params = params.append('commaServiceIds', serviceIds.join(','));
    params = params.append('source', source);
    if (fromDate) {
      params = params.append('fromDate', fromDate.toDateString());
    }
    if (toDate) {
      params = params.append('toDate', toDate.toDateString());

    }

    const headers = this.getOperatorHeader(operator);
    return this.http.get<OperatorDetails[]>(
      this.baseApi + '/OperatorDetails?',
      { headers: headers, params: params }
    );
  }
}
